
(function(){
  'use strict';
  var variantDataCache=null;

  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn,{once:true});}

  function cleanName(name){
    name=(name||'').replace(/\s*:\s*$/,'').trim();
    if(/^personaliz/i.test(name))return 'Personalization';
    if(/^colors$/i.test(name))return 'Color';
    return name;
  }

  function updateHeader(swatch){
    var header=swatch.querySelector('.header');
    var checked=swatch.querySelector('input[type="radio"]:checked');
    if(!header)return;
    var name=cleanName(swatch.getAttribute('data-option-name')||header.textContent);
    header.innerHTML='';
    var title=document.createElement('span');
    title.className='bb-option-title';
    title.textContent=name;
    var current=document.createElement('strong');
    current.className='bb-option-current';
    current.textContent=checked ? checked.value : 'Choose an option';
    header.appendChild(title);
    header.appendChild(current);
  }

  function getVariantData(){
    if(variantDataCache)return variantDataCache;
    var node=document.getElementById('BBVariantMediaData');
    if(!node)return {variants:[]};
    try{variantDataCache=JSON.parse(node.textContent||'{}');}
    catch(e){variantDataCache={variants:[]};}
    return variantDataCache;
  }

  function selectedOptions(form,count){
    var values=[];
    for(var i=0;i<count;i++){
      var radio=form.querySelector('.swatch[data-option-index="'+i+'"] input[type="radio"]:checked');
      if(radio){values.push(radio.value);continue;}
      var selectors=form.querySelectorAll('.single-option-selector');
      values.push(selectors[i] ? selectors[i].value : '');
    }
    return values;
  }

  function selectedVariant(form){
    var data=getVariantData();
    if(!data.variants||!data.variants.length)return null;
    var count=data.variants[0].options ? data.variants[0].options.length : 0;
    var values=selectedOptions(form,count);
    for(var i=0;i<data.variants.length;i++){
      var v=data.variants[i],match=true;
      for(var x=0;x<count;x++){
        if(String(v.options[x])!==String(values[x])){match=false;break;}
      }
      if(match)return v;
    }
    var master=form.querySelector('#productSelect');
    if(master){
      for(var j=0;j<data.variants.length;j++){
        if(String(data.variants[j].id)===String(master.value))return data.variants[j];
      }
    }
    return null;
  }

  function normalize(url){
    return String(url||'').replace(/^https?:/,'').split('?')[0];
  }

  function syncActiveThumb(src){
    var thumbs=document.querySelectorAll('#ProductThumbs a[data-image]');
    if(!thumbs.length)return;
    var wanted=normalize(src);
    thumbs.forEach(function(a){
      a.classList.toggle('active',normalize(a.getAttribute('data-image'))===wanted);
    });
  }

  function swapImage(image){
    if(!image||!image.src)return;
    var img=document.getElementById('product-featured-image');
    if(!img)return;
    if(normalize(img.getAttribute('src'))===normalize(image.src)){
      syncActiveThumb(image.src);
      return;
    }

    img.classList.add('bb-image-is-switching');
    var preload=new Image();
    preload.onload=function(){
      var $=window.jQuery;
      var zoom=$ && $.fn ? $(img).data('elevateZoom') : null;

      if(zoom&&typeof zoom.swaptheimage==='function'){
        zoom.swaptheimage(image.src,image.zoom||image.src);
      }else{
        img.setAttribute('src',image.src);
        img.setAttribute('data-zoom-image',image.zoom||image.src);
      }

      if(image.alt)img.setAttribute('alt',image.alt);
      var link=img.closest('a');
      if(link&&image.zoom)link.setAttribute('href',image.zoom);
      syncActiveThumb(image.src);
      requestAnimationFrame(function(){img.classList.remove('bb-image-is-switching');});
    };
    preload.onerror=function(){img.classList.remove('bb-image-is-switching');};
    preload.src=image.src;
  }

  function syncVariantImage(form){
    var variant=selectedVariant(form);
    if(variant&&variant.image)swapImage(variant.image);
  }

  function init(){
    var form=document.getElementById('AddToCartForm');
    if(!form)return;

    document.querySelectorAll('#AddToCartForm .swatch').forEach(function(swatch){
      updateHeader(swatch);
      swatch.querySelectorAll('input[type="radio"]').forEach(function(input){
        input.addEventListener('change',function(){
          updateHeader(swatch);
          setTimeout(function(){syncVariantImage(form);},30);
        });
      });
    });

    form.querySelectorAll('.single-option-selector').forEach(function(select){
      select.addEventListener('change',function(){setTimeout(function(){syncVariantImage(form);},30);});
    });

    setTimeout(function(){syncVariantImage(form);},120);
  }

  ready(init);
})();
